export enum NotificationType {
  Email = 1,
  EmailWithoutAttachment = 2,
}
